var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginBackgroundDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 295,
    viewBox: "0 0 237 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 211.379,
    y1: 7.57476,
    x2: 223.645,
    y2: 9.73767,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 236.038,
    y1: 20.4109,
    x2: 247.743,
    y2: 24.671,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 151.974,
    y1: -0.568359,
    x2: 164.43,
    y2: -0.568359,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 176.211,
    y1: 12.44,
    x2: 188.477,
    y2: 14.6029,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 200.87,
    y1: 25.2771,
    x2: 212.575,
    y2: 29.5372,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 238.244,
    y1: 47.7977,
    x2: 227.457,
    y2: 41.5698,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 116.804,
    y1: 4.29395,
    x2: 129.259,
    y2: 4.29395,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 141.04,
    y1: 17.3033,
    x2: 153.306,
    y2: 19.4662,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 165.699,
    y1: 30.1394,
    x2: 177.404,
    y2: 34.3995,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 203.072,
    y1: 52.6609,
    x2: 192.285,
    y2: 46.4331,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 226.493,
    y1: 67.5131,
    x2: 216.952,
    y2: 59.5067,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 81.6357,
    y1: 9.16016,
    x2: 94.0914,
    y2: 9.16016,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 105.872,
    y1: 22.1695,
    x2: 118.139,
    y2: 24.3324,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 130.531,
    y1: 35.0056,
    x2: 142.236,
    y2: 39.2657,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 237.71,
    y1: 101.27,
    x2: 231.482,
    y2: 90.4826,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 167.905,
    y1: 57.5262,
    x2: 157.118,
    y2: 51.2983,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 191.325,
    y1: 72.3793,
    x2: 181.784,
    y2: 64.373,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 214.525,
    y1: 87.0705,
    x2: 206.519,
    y2: 77.5289,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 70.7013,
    y1: 27.0318,
    x2: 82.9677,
    y2: 29.1947,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 95.3602,
    y1: 39.8689,
    x2: 107.065,
    y2: 44.129,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 202.538,
    y1: 106.133,
    x2: 196.311,
    y2: 95.3459,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 225.345,
    y1: 120.532,
    x2: 221.085,
    y2: 108.828,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 132.734,
    y1: 62.3904,
    x2: 121.947,
    y2: 56.1626,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 156.154,
    y1: 77.2426,
    x2: 146.612,
    y2: 69.2362,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 179.354,
    y1: 91.9328,
    x2: 171.348,
    y2: 82.3912,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 60.1927,
    y1: 44.7341,
    x2: 71.8973,
    y2: 48.9942,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 167.371,
    y1: 110.998,
    x2: 161.143,
    y2: 100.211,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 190.174,
    y1: 125.397,
    x2: 185.914,
    y2: 113.692,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 213.014,
    y1: 139.34,
    x2: 210.851,
    y2: 127.073,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 235.919,
    y1: 152.85,
    x2: 235.919,
    y2: 140.394,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 97.5662,
    y1: 67.2547,
    x2: 86.7792,
    y2: 61.0268,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 120.987,
    y1: 82.1078,
    x2: 111.445,
    y2: 74.1015,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 144.186,
    y1: 96.799,
    x2: 136.18,
    y2: 87.2574,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 132.2,
    y1: 115.862,
    x2: 125.972,
    y2: 105.075,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 155.006,
    y1: 130.262,
    x2: 150.746,
    y2: 118.557,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 177.846,
    y1: 144.206,
    x2: 175.683,
    y2: 131.939,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 200.752,
    y1: 157.714,
    x2: 200.752,
    y2: 145.258,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 223.563,
    y1: 171.152,
    x2: 225.725,
    y2: 158.885,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 62.3949,
    y1: 72.119,
    x2: 51.6079,
    y2: 65.8911,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 85.8153,
    y1: 86.9721,
    x2: 76.2737,
    y2: 78.9657,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 109.015,
    y1: 101.662,
    x2: 101.009,
    y2: 92.1207,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 97.0322,
    y1: 120.727,
    x2: 90.8043,
    y2: 109.94,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 119.835,
    y1: 135.125,
    x2: 115.575,
    y2: 123.421,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 142.675,
    y1: 149.068,
    x2: 140.512,
    y2: 136.802,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 165.581,
    y1: 162.578,
    x2: 165.581,
    y2: 150.122,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 188.395,
    y1: 176.017,
    x2: 190.558,
    y2: 163.75,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 211.154,
    y1: 189.412,
    x2: 215.415,
    y2: 177.707,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 234.093,
    y1: 202.455,
    x2: 240.321,
    y2: 191.668,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 50.6479,
    y1: 91.8364,
    x2: 41.1063,
    y2: 83.83,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 73.8477,
    y1: 106.528,
    x2: 65.8413,
    y2: 96.9859,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 61.8608,
    y1: 125.591,
    x2: 55.633,
    y2: 114.804,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 84.6671,
    y1: 139.991,
    x2: 80.407,
    y2: 128.287,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 107.507,
    y1: 153.934,
    x2: 105.344,
    y2: 141.668,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 130.413,
    y1: 167.443,
    x2: 130.413,
    y2: 154.988,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 153.224,
    y1: 180.88,
    x2: 155.387,
    y2: 168.614,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 175.983,
    y1: 194.276,
    x2: 180.243,
    y2: 182.572,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 198.922,
    y1: 207.319,
    x2: 205.15,
    y2: 196.532,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 221.89,
    y1: 220.38,
    x2: 229.897,
    y2: 210.838,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 38.6764,
    y1: 111.392,
    x2: 30.67,
    y2: 101.85,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 209.946,
    y1: 238.009,
    x2: 219.488,
    y2: 230.003,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 233.277,
    y1: 250.847,
    x2: 244.064,
    y2: 244.619,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 26.6929,
    y1: 130.456,
    x2: 20.4651,
    y2: 119.669,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 49.4962,
    y1: 144.854,
    x2: 45.2361,
    y2: 133.149,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 72.3364,
    y1: 158.798,
    x2: 70.1735,
    y2: 146.531,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    x1: 95.2418,
    y1: 172.307,
    x2: 95.2418,
    y2: 159.851,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    x1: 118.056,
    y1: 185.746,
    x2: 120.219,
    y2: 173.48,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    x1: 140.816,
    y1: 199.14,
    x2: 145.076,
    y2: 187.436,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    x1: 163.754,
    y1: 212.184,
    x2: 169.982,
    y2: 201.397,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    x1: 186.72,
    y1: 225.242,
    x2: 194.726,
    y2: 215.7,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    x1: 174.779,
    y1: 242.874,
    x2: 184.32,
    y2: 234.867,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    x1: 198.106,
    y1: 255.711,
    x2: 208.893,
    y2: 249.483,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    x1: 221.574,
    y1: 268.645,
    x2: 233.279,
    y2: 264.385,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    x1: 14.3283,
    y1: 149.72,
    x2: 10.0682,
    y2: 138.015,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    x1: 37.1685,
    y1: 163.663,
    x2: 35.0055,
    y2: 151.396,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    x1: 60.0739,
    y1: 177.173,
    x2: 60.0739,
    y2: 164.717,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    x1: 82.885,
    y1: 190.609,
    x2: 85.0479,
    y2: 178.342,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    x1: 105.644,
    y1: 204.005,
    x2: 109.904,
    y2: 192.3,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    x1: 128.583,
    y1: 217.048,
    x2: 134.811,
    y2: 206.261,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    x1: 151.552,
    y1: 230.108,
    x2: 159.558,
    y2: 220.567,
    stroke: "#F2F4F7",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackgroundDetail);
export default __webpack_public_path__ + "static/media/LoginBackgroundDetail.e21d8bc8dc7fad571dde8a18246eb2cb.svg";
export { ForwardRef as ReactComponent };